import { IconProps } from '@/types/icon';

export function IconeCarrinho({ size, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="carrinho"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M13.7891 10.8337C14.4141 10.8337 14.9641 10.492 15.2474 9.97533L18.2307 4.56699C18.5391 4.01699 18.1391 3.33366 17.5057 3.33366H5.1724L4.38906 1.66699H1.66406V3.33366H3.33073L6.33073 9.65866L5.20573 11.692C4.5974 12.8087 5.3974 14.167 6.66406 14.167H16.6641V12.5003H6.66406L7.58073 10.8337H13.7891ZM5.96406 5.00033H16.0891L13.7891 9.16699H7.93906L5.96406 5.00033ZM6.66406 15.0003C5.7474 15.0003 5.00573 15.7503 5.00573 16.667C5.00573 17.5837 5.7474 18.3337 6.66406 18.3337C7.58073 18.3337 8.33073 17.5837 8.33073 16.667C8.33073 15.7503 7.58073 15.0003 6.66406 15.0003ZM14.9974 15.0003C14.0807 15.0003 13.3391 15.7503 13.3391 16.667C13.3391 17.5837 14.0807 18.3337 14.9974 18.3337C15.9141 18.3337 16.6641 17.5837 16.6641 16.667C16.6641 15.7503 15.9141 15.0003 14.9974 15.0003Z"
        fill="currentColor"
      />
    </svg>
  );
}
